<template>
  <page>
    <template slot="content">
    <help-content :title="'開封後ペアリングできない'">
      <template slot="content">
        <div class="text">
          別のスマホでWeBandのファームウェアをアップデートしてから接続し直してください。<br><br>
          １．一旦、iPhoneや他のペアリングできるスマホにWeBandを接続します。<br><br>
          ２．アプリのホーム画面に切替え<b>ファームウェアの自動アップデート</b>が実行されます。終了まで画面を閉じずお待ちください。<br><br>
          ３．「WeBand＞もっと＞デバイス情報＞ペアリング解除」でペアリングを解除してから、元のスマホに接続します。
        </div>
        <img class="picture" src="../assets/images/q_and_a/H29.png">
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help29.vue